export const planningItem = {
    suppress: {
        title: "Suppression du planning",
        message: "Voulez-vous vraiment supprimer ce planning ?",
    },
    'display-planning': "Afficher le planning : {name}",
}